import React, { useState, useEffect, useRef } from 'react';
import { getAllEnvironments } from '../../api/documentAPI';
import { useTranslation } from 'react-i18next';

import '../../css/pages/manage_teams.css';

export default function EnvironmentsMultiselect({ selectedValues, onChange }) {
    
    const [t] = useTranslation('global');
    const [environments, setEnvironments] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchEnvironments = async () => {
            try {
                const response = await getAllEnvironments();
                const envs = response.map((env) => ({
                    value: env.Id,
                    label: env.Name,
                }));
                setEnvironments(envs);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchEnvironments();
    }, []);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false); // Close dropdown
            }
        };

        document.addEventListener('mousedown', handleClickOutside); // Listen for clicks
        return () => {
            document.removeEventListener('mousedown', handleClickOutside); // Cleanup on unmount
        };
    }, []);

    const handleSelect = (value) => {
        if (selectedValues.includes(value)) {
            // Remove value
            onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
        } else {
            // Add value
            onChange({ target: { value: [...selectedValues, value] } });
        }
    };

    const handleDelete = (value) => {
        onChange({ target: { value: selectedValues.filter((v) => v !== value) } });
    };

    const filteredEnvironments = environments.filter((env) =>
        env.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="mill-multiselect" ref={dropdownRef}>
            <label>{t('environments')}</label>
            <div className="multiselect-line" onClick={toggleDropdown}>
                <div className="selected-values">
                    {selectedValues.map((value) => (
                        <span key={value} className="selected-chip">
                            {environments.find((env) => env.value === value)?.label || value}
                            <button className="delete-chip" onClick={() => handleDelete(value)}>
                                &times;
                            </button>
                        </span>
                    ))}
                </div>
                <span className="dropdown-icon material-symbols-outlined">
                    {isDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </div>
            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <div className='search-input-wrapper'>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={t('search')}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <ul className="dropdown-list">
                        {filteredEnvironments.map((env) => (
                            <li key={env.value}
                                className={`dropdown-item ${
                                    selectedValues.includes(env.value) ? "selected" : ""
                                }`}
                                onClick={() => handleSelect(env.value)}
                            >
                                {env.label}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
